module.exports = __webpack_public_path__ + "logo-bigcommerce.48256b0ac4f829dd34698ff1438511fc.svg";